import Vue from 'vue'
import vuetify from './plugins/vuetify'
import router from '@/router'
import App from './App.vue'
import 'vue-toastification/dist/index.css'
import Toast, { POSITION } from 'vue-toastification'

Vue.use(Toast, {
  // Setting the global default position
  position: POSITION.BOTTOM_RIGHT,
  showCloseButtonOnHover: true,
  toastClassName: 'hublot-toast',
  shareAppContext: true,
})

new Vue({
  router,
  vuetify,
  render: h => h(App),
}).$mount('#app')
